import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OohCourierTripsQueryVariables = Types.Exact<{
  routeId: Types.Scalars['ID'];
  date?: Types.InputMaybe<Types.Scalars['Date']>;
}>;


export type OohCourierTripsQuery = { __typename?: 'Query', OohCourierTrips: Array<{ __typename?: 'OohCourierTrip', courierId: number, indicative: string, agencyCourierVisits: Array<{ __typename?: 'AgencyCourierVisit', visitDate?: any | null, visitSessionNumber?: any | null, visitStartTime?: any | null, visitEndTime?: any | null, visitPickupCharges?: any | null, parcelsStillInAgency?: any | null }>, locationTrips: Array<{ __typename?: 'OohTrip', warehouseDepartureTime: any, warehouseReturnTime: any, oohCourierVisits: Array<{ __typename?: 'OohCourierVisit', oohId?: number | null, visitCharges?: any | null, visitDischargesC2C?: any | null, visitDischargesExpired?: any | null, visitDischargesFirstMile?: any | null, visitDischargesReturn?: any | null, oohPoint?: { __typename?: 'OohPoint', name?: string | null, capacity: number, id: any, latitude: number, longitude: number } | null }> }>, courierTotals?: { __typename?: 'CourierTotals', totalDeliveries?: number | null, totalC2CDischarges?: number | null, totalFMDischarges?: number | null, totalExpired?: number | null, totalReturns?: number | null } | null }> };


export const OohCourierTripsDocument = gql`
    query OohCourierTrips($routeId: ID!, $date: Date) {
  OohCourierTrips(routeId: $routeId) {
    courierId
    indicative
    agencyCourierVisits(date: $date) {
      visitDate
      visitSessionNumber
      visitStartTime
      visitEndTime
      visitPickupCharges
      parcelsStillInAgency
    }
    locationTrips(date: $date) {
      warehouseDepartureTime
      warehouseReturnTime
      oohCourierVisits(date: $date) {
        oohId
        oohPoint {
          name
          capacity
          id
          latitude
          longitude
        }
        visitCharges
        visitDischargesC2C
        visitDischargesExpired
        visitDischargesFirstMile
        visitDischargesReturn
      }
    }
    courierTotals(date: $date) {
      totalDeliveries
      totalC2CDischarges
      totalFMDischarges
      totalExpired
      totalReturns
    }
  }
}
    `;

/**
 * __useOohCourierTripsQuery__
 *
 * To run a query within a React component, call `useOohCourierTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOohCourierTripsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOohCourierTripsQuery({
 *   variables: {
 *      routeId: // value for 'routeId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useOohCourierTripsQuery(baseOptions: Apollo.QueryHookOptions<OohCourierTripsQuery, OohCourierTripsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OohCourierTripsQuery, OohCourierTripsQueryVariables>(OohCourierTripsDocument, options);
      }
export function useOohCourierTripsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OohCourierTripsQuery, OohCourierTripsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OohCourierTripsQuery, OohCourierTripsQueryVariables>(OohCourierTripsDocument, options);
        }
export type OohCourierTripsQueryHookResult = ReturnType<typeof useOohCourierTripsQuery>;
export type OohCourierTripsLazyQueryHookResult = ReturnType<typeof useOohCourierTripsLazyQuery>;
export type OohCourierTripsQueryResult = Apollo.QueryResult<OohCourierTripsQuery, OohCourierTripsQueryVariables>;